/**
 * Home hero background effect — set HERO_BACKDROP_VARIANT to preview.
 *
 * digital — Terafab.ai-style pixel mosaic (dark hero, purple → cyan shimmer)
 * mesh, aurora, orbs, constellation, grain, grid, dust — lighter CSS effects
 */
export const HERO_BACKDROP_VARIANT = 'digital';

/** digital uses a dark hero; other variants use the default light hero */
export function getHeroBackdropTone(variant) {
  return variant === 'digital' ? 'dark' : 'light';
}

export function isDigitalHero(variant) {
  return variant === 'digital';
}

/** @deprecated Use HERO_BACKDROP_VARIANT */
export const HERO_STARFIELD_VARIANT = HERO_BACKDROP_VARIANT;

export const HERO_BACKDROP_OPTIONS = [
  {
    id: 'digital',
    label: 'Digital mosaic',
    description: 'Animated pixel grid with purple → cyan gradient — like Terafab.ai',
    portfolio: 'Terafab.ai, high-tech launch pages',
  },
  {
    id: 'mesh',
    label: 'Gradient mesh',
    description: 'Fluid color mesh — popular on Awwwards / SaaS landings (Effect Labs, SyntaxSnap)',
    portfolio: 'Linear, Stripe-style heroes',
  },
  {
    id: 'aurora',
    label: 'Aurora',
    description: 'Soft blurred color blobs that drift slowly — northern-lights style',
    portfolio: 'AI dashboards, modern dev portfolios',
  },
  {
    id: 'orbs',
    label: 'Floating orbs',
    description: 'Lighter, fewer blobs — depth without heavy blur',
    portfolio: 'Framer / Webflow agency sites',
  },
  {
    id: 'constellation',
    label: 'Constellation',
    description: 'Gentle twinkling dots + brand glow — space hint, stays readable on white',
    portfolio: 'Lily-style starfield (light mode, no streaks)',
  },
  {
    id: 'grain',
    label: 'Film grain',
    description: 'Subtle cinematic texture — premium editorial portfolios',
    portfolio: 'High-end design / photography sites',
  },
  {
    id: 'grid',
    label: 'Dot grid',
    description: 'Faded technical grid — clean dev / product portfolios',
    portfolio: 'Vercel, developer portfolio templates',
  },
  {
    id: 'dust',
    label: 'Stardust',
    description: 'Barely-there static specks — most minimal',
    portfolio: 'Minimal Swiss / brutalist portfolios',
  },
];

export const STARFIELD_VARIANT_OPTIONS = HERO_BACKDROP_OPTIONS;
